// extracted by mini-css-extract-plugin
export default {"cardWrapper":"Statistics_cardWrapper__681WR","card":"Statistics_card__t+lzq","round":"Statistics_round__RmHWQ","title":"Statistics_title__R6jep"};